// Связь с менеджером: открытие t.me-чата из Mini App.

/** Открывает чат с менеджером (t.me-ссылка) внутри Telegram, с фолбэком. */
export function contactManager(url: string): void {
  const tg = window.Telegram?.WebApp;
  if (tg?.openTelegramLink) tg.openTelegramLink(url);
  else window.open(url, "_blank");
}

/** Копирует готовый вопрос о товаре в буфер и открывает чат с менеджером. */
export async function askAboutProduct(url: string, text: string): Promise<boolean> {
  let copied = false;
  try {
    await navigator.clipboard.writeText(text);
    copied = true;
  } catch {
    /* буфер недоступен — просто откроем чат */
  }
  contactManager(url);
  return copied;
}
